import actions from './actions';
import { getters, state, mutations } from './mutations';

export default {
  actions,
  getters,
  state,
  mutations,
};
